// extracted by mini-css-extract-plugin
module.exports = {"playButton":"aboutUs_playButton__wWOt5"};